// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__FKjU3","loader":"styles_loader__Rqows","anim":"styles_anim__Nhjix"};